import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Award, Target, Gift, Crown, Leaf, Shield, Flame, Zap, Users, Compass, Flag } from "lucide-react";
import { API, axios } from "@/api";
import { useTheme } from "@/contexts/ThemeContext";

const ICON_MAP = {
  gift: Gift, target: Target, crown: Crown, leaf: Leaf, award: Award,
  "shield-check": Shield, flame: Flame, zap: Zap, users: Users,
  compass: Compass, flag: Flag,
};

export default function BadgeChaseCard() {
  const [badges, setBadges] = useState([]);
  const { theme } = useTheme();

  useEffect(() => {
    axios.get(`${API}/gamification/badge-chase`)
      .then(r => setBadges(r.data))
      .catch(() => {});
  }, []);

  if (!badges.length) return null;

  return (
    <section className="bg-white rounded-2xl shadow-sm border border-slate-100 p-4" data-testid="badge-chase-card">
      <div className="flex items-center gap-2 mb-3">
        <Award className="w-4 h-4" style={{ color: theme.primary }} />
        <h3 className="text-sm font-bold text-slate-700">Almost there</h3>
      </div>
      <div className="space-y-3">
        {badges.map((b, i) => {
          const Icon = ICON_MAP[b.badge_icon] || Award;
          return (
            <motion.div
              key={b.badge_id}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.1 }}
              className="flex items-center gap-3"
              data-testid={`badge-chase-${b.badge_id}`}
            >
              <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: `${theme.primary}15` }}>
                <Icon className="w-4 h-4" style={{ color: theme.primary }} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs font-semibold text-slate-700 truncate">{b.badge_name}</span>
                  <span className="text-[10px] text-slate-400 shrink-0 ml-1">{b.remaining} more</span>
                </div>
                <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                  <motion.div
                    className="h-full rounded-full"
                    style={{ backgroundColor: theme.primary }}
                    initial={{ width: 0 }}
                    animate={{ width: `${b.progress_pct}%` }}
                    transition={{ duration: 0.6, delay: i * 0.1 }}
                  />
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
